import React, { useState } from "react";
import { TextField, Box, Typography, Container, CssBaseline } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { AuthFormProps } from "../interfaces/interface";

const AuthForm: React.FC<AuthFormProps> = ({ onAuthenticate, isStudent = false }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      onAuthenticate(email, password);
    } catch (error) {
      console.error("Erro durante a autenticação:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      {/* <CssBaseline /> */}
        {/* <Container maxWidth="sm"> */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // Coluna no mobile, linha no desktop
              height: "100vh",
              width: "100vw",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#e1efff",
              padding: 2,
            }}
          >
            {/* Imagem do lado esquerdo */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" }, // 100% no mobile, 50% no desktop
                height: { xs: "667px", md: "80%" }, // Altura reduzida no mobile
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={isStudent ? "/images/logins/logo_aluno.png" : "/images/logins/livros.svg"}
                alt="Logo Aluno"
                style={{
                  maxWidth: "80%", // Ajusta a largura da imagem
                  height: "auto",
                }}
              />
            </Box>

            {/* Formulário */}
            <Box
              sx={{
                width: { xs: "100%", md: "50%" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: 2, md: 4 }, // Menos padding no mobile
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: 20, md: 24 }, // Menor fonte no mobile
                  fontWeight: "bold",
                  letterSpacing: "8px",
                  color: "#95979a",
                  textAlign: "center",
                }}
              >
                login
              </Typography>

              <TextField
                label={isStudent ? "matrícula" : "email"}
                type={isStudent ? "text" : "email"}
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{
                  width: "90%", // Em vez de valor fixo, usa % para adaptar
                  maxWidth: "400px",
                  letterSpacing: "4px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "25px",
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "white",
                    },
                    fontSize: 16,
                  },
                }}
              />

              {!isStudent && (
                <TextField
                  label="senha"
                  type="password"
                  fullWidth
                  margin="normal"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  sx={{
                    width: "90%",
                    maxWidth: "400px",
                    letterSpacing: "4px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "25px",
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "white",
                      },
                      fontSize: 16,
                    },
                  }}
                />
              )}

              <LoadingButton
                type="submit"
                fullWidth
                loading={isLoading}
                sx={{
                  mt: 2,
                  width: "90%",
                  maxWidth: "400px",
                }}
              >
                {isLoading ? null : (
                  <img src="/images/logins/entrar.svg" alt="Entrar" />
                )}
              </LoadingButton>
            </Box>

            {/* Rodapé */}
            <Box
              sx={{
                position: "absolute",
                bottom: 16,
                right: { xs: "50%", md: 16 }, // Centraliza no mobile
                transform: { xs: "translateX(50%)", md: "none" },
                textAlign: "center",
              }}
            >
              <img
                src="/images/logins/logo_rodape.png"
                alt="Logo Rodapé"
                style={{
                  width: "189px", // Menor no mobile
                  maxWidth: "100%",
                }}
              />
            </Box>
          </Box>
        {/* </Container> */}
    </React.Fragment>
  );
};

export default AuthForm;